import { render, staticRenderFns } from "./DashboardAdminDKP.vue?vue&type=template&id=7728bcb3&scoped=true&"
import script from "./DashboardAdminDKP.vue?vue&type=script&lang=js&"
export * from "./DashboardAdminDKP.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAdminDKP.vue?vue&type=style&index=0&id=7728bcb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7728bcb3",
  null
  
)

export default component.exports